import { useEffect, useState } from 'react'
const useEleListHeight = (eleClass) => {
  const [totalHeight, setHeight] = useState(0 + 'px')
  useEffect(() => {
    let eleName = document.querySelectorAll(eleClass)
    let lgth = 0
    for (let i = 0, len = eleName.length; i < len; i++) {
      if (eleName[i].clientHeight > lgth) {
        lgth = eleName[i].clientHeight
      }
    }
    setHeight(lgth + 'px')
  })
  return totalHeight
}
export default useEleListHeight
